<script lang="ts">
  import Select from '../ui/Select.svelte';
  import { getAppearance } from '../themes/appearance.svelte';
  import { DEFAULT_THEME, THEMES } from '../themes/registry';
  const appearance = getAppearance();
</script>

<label for="theme-choice">Theme</label>
<Select
  id="theme-choice"
  aria-label="Theme"
  value={appearance.theme.id}
  onchange={appearance.selectTheme}
  options={THEMES.map((theme) => ({
    value: theme.id,
    label: theme.name + (theme.id === DEFAULT_THEME.id ? ' (default)' : ''),
  }))}
/>
{#if appearance.theme.preview}
  <img
    class="theme-preview"
    src={appearance.theme.preview}
    alt={`${appearance.theme.name} landscape preview`}
  />
{/if}
<p class="hint">{appearance.theme.description}</p>
<label class="preference">Animations <input type="checkbox" bind:checked={appearance.animations} /></label>
<label class="preference">Background music <input type="checkbox" bind:checked={appearance.music} /></label>
<label class="preference">Ambient sounds <input type="checkbox" bind:checked={appearance.ambience} /></label>
<label class="preference">Sound effects <input type="checkbox" bind:checked={appearance.effects} /></label>

<style>
  .preference {
    min-height: 44px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 44px;
    align-items: center;
    gap: 8px;
  }
  .preference input {
    justify-self: center;
    width: 24px;
    min-width: 24px;
    height: 24px;
    accent-color: var(--theme-accent);
  }

  .theme-preview {
    width: 100%;
    height: 110px;
    object-fit: cover;
    object-position: center 65%;
    border-radius: var(--theme-input-radius);
    border: var(--theme-card-border);
  }
</style>
